var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ShowHideB" },
    [
      !_setup.opened
        ? _c("div", { on: { click: _setup.toggle } }, [_vm._t("title")], 2)
        : _vm._e(),
      _vm._v(" "),
      _setup.opened ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      _setup.opened
        ? _c(
            "button",
            { staticClass: "ShowHideB--close", on: { click: _setup.toggle } },
            [_c(_setup.CloseSvg, { staticClass: "close-icon" })],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }